import { defineComponent as _defineComponent } from 'vue'
type Props ={
  isLoading?: boolean,
  color?: string,
  size?: number,
  absolute?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingSpinner',
  props: {
    isLoading: { type: Boolean, default: false },
    color: { default: "white" },
    size: { default: 32 },
    absolute: { type: Boolean, default: true }
  },
  setup(__props: any) {






return { __sfc: true, }
}

})